import { createStore, createLogger } from "vuex";
import initDictionaries from "@/utils/initDictionary";

import classs from "./modules/class";

const debug = process.env.NODE_ENV !== "production";

const store = createStore({
  state: () => ({
    dictionaries: {},
  }),
  mutations: {
    setDictionaries(state, data) {
      state.dictionaries = data;
    },
  },
  actions: {
    async initDictionaries(context) {
      context.commit("setDictionaries", await initDictionaries());
    },
  },
  modules: {
    class: classs,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});

export default store;
